/* Maison Byōbu · le parcours d'achat en étapes (10/10, chantier matières ; demande de Marcel : « que ce soit hyper simple »).
   Une couche d'affichage posée sur le cadreur (assets/mb-cadreur.js) : elle ouvre une étape à la fois, coche la
   progression, écrit les résumés, le reçu, le total de chaque matière et « Vos avantages ». Elle ne calcule aucun prix à
   sa façon : tout vient du moteur (tarifImprime, devis, imp, matiere) et des constantes de remise (window.mbRemises).
   Le moteur garde ses champs, sa case, son bouton, Apippa et ses messages ; ses gestes qui amènent un élément à l'écran
   (case, champs, autre pièce, Voir chez moi) ouvrent d'abord la bonne étape.
   Aussi : les chiffres de « La matière » qui s'égrènent (data-mb-compte), et l'exemple de prix du premier écran.
   Uniquement transform et opacity pour le mouvement ; rien ne s'anime en mouvement réduit. */
(() => {
  if (window.mbAchatEtapes) return;
  window.mbAchatEtapes = true;
  const d = document;
  const anime = d.documentElement.classList.contains('mb-js') && !matchMedia('(prefers-reduced-motion: reduce)').matches;
  const euros = (c) => (typeof mbEuros !== 'undefined' ? mbEuros : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })).format(c / 100);
  const sansZero = (t) => t.replace(/[,.]00(?=\D|$)/, '');
  const metres = (cm) => new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(cm / 100);
  /* « 1 292,11 € » → 129211 ; null si ce n'est pas un montant */
  const centimesDe = (t) => { const m = String(t || '').replace(/[\s  €]/g, '').replace(',', '.'); const n = parseFloat(m); return Number.isFinite(n) ? Math.round(n * 100) : null; };
  /* Le prix glisse doucement vers son nouveau montant (texte seulement, 600 ms), jamais en mouvement réduit */
  const glisserMontant = (el, texte) => {
    if (!el) return;
    const vers = centimesDe(texte);
    const de = el.dataset.centimes != null ? Number(el.dataset.centimes) : null;
    if (vers == null || de == null || !anime || de === vers) { el.textContent = texte; if (vers != null) el.dataset.centimes = String(vers); return; }
    el.dataset.centimes = String(vers);
    const t0 = performance.now(); const duree = 600; const jeton = (el.mbJeton = (el.mbJeton || 0) + 1);
    const pas = (t) => {
      if (el.mbJeton !== jeton) return;
      const p = Math.min((t - t0) / duree, 1); const e = 1 - Math.pow(1 - p, 3);
      el.textContent = p < 1 ? euros(Math.round(de + (vers - de) * e)) : texte;
      if (p < 1) requestAnimationFrame(pas);
    };
    requestAnimationFrame(pas);
  };

  /* ---------- Les chiffres de « La matière » : de 0 à leur valeur, une fois, à l'apparition ---------- */
  const comptes = [...d.querySelectorAll('[data-mb-compte]')];
  if (comptes.length && anime && 'IntersectionObserver' in window) {
    const compter = (el) => {
      const fin = parseInt(el.dataset.mbCompte, 10) || 0;
      if (!fin) return;
      const t0 = performance.now();
      const duree = 900 + Math.min(fin, 100) * 6;
      const pas = (t) => {
        const p = Math.min((t - t0) / duree, 1);
        el.textContent = String(Math.round(fin * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(pas);
      };
      requestAnimationFrame(pas);
    };
    const io = new IntersectionObserver((entrees) => {
      for (const e of entrees) { if (!e.isIntersecting) continue; io.unobserve(e.target); compter(e.target); }
    }, { threshold: 0.6 });
    for (const el of comptes) { if (parseInt(el.dataset.mbCompte, 10)) el.textContent = '0'; io.observe(el); }
  }

  if (!('customElements' in window)) return;
  customElements.whenDefined('mb-cadreur').then(() => {
    for (const c of d.querySelectorAll('mb-cadreur')) if (c.el) monter(c);
  });

  function monter(c) {
    const racine = c.querySelector('[data-mb-etapes]');
    exemplePremierEcran(c);
    if (!racine || racine.dataset.monte) return;
    racine.dataset.monte = 'oui';
    c.dataset.parcours = 'etapes';
    const pas = [...racine.querySelectorAll('[data-mb-pas]')].filter((p) => !p.hasAttribute('data-mb-pas-absent'));
    const cles = pas.map((p) => p.dataset.mbPas);
    const prog = c.querySelector('[data-mb-progression]');
    const repete = c.dataset.repete === 'oui';
    const etat = { ouvert: null, valides: new Set(['oeuvre']) }; // l'œuvre est choisie avant d'arriver (catalogue)
    const aside = c.querySelector('.mb-cadreur__vivant');
    const atelier = aside && aside.hasAttribute('data-vue');
    pas.forEach((p, i) => { const n = p.querySelector('[data-mb-pas-num]'); if (n) n.textContent = String(i + 1); });
    const pasDe = (cle) => pas.find((p) => p.dataset.mbPas === cle);
    const pret = () => c.dataset.etat === 'pret';

    /* ---------- Ouvrir une étape ---------- */
    const ouvrir = (cle, { defiler = true } = {}) => {
      if (!cles.includes(cle)) return;
      /* Rien après « Vos mesures » sans mesures valides (10/10, Marcel) : on y revient, avec la phrase qui guide */
      if (cles.includes('mur') && cles.indexOf(cle) > cles.indexOf('mur') && !pret()) {
        c.lire(true);
        if (!pret()) {
          const v = c.valider();
          c.erreur(c.el.L.value || c.el.H.value ? v.texte : 'Indiquez d’abord la largeur et la hauteur de votre mur, en centimètres.');
          if (etat.ouvert !== 'mur') ouvrir('mur', { defiler });
          (v.champ || c.el.L).focus({ preventScroll: !defiler });
          return;
        }
      }
      const avant = etat.ouvert;
      // une étape quittée vers l'avant compte comme faite (le choix par défaut est un choix)
      if (avant && cles.indexOf(cle) > cles.indexOf(avant) && (avant !== 'mur' || pret())) etat.valides.add(avant);
      etat.ouvert = cle;
      for (const p of pas) {
        const oui = p.dataset.mbPas === cle;
        const corps = p.querySelector('[data-mb-pas-corps]');
        p.querySelector('.mb-pas__bouton').setAttribute('aria-expanded', String(oui));
        p.toggleAttribute('data-ouvert', oui);
        if (corps.hidden === !oui) continue;
        corps.hidden = !oui;
        if (oui && anime) { corps.classList.remove('mb-entre'); void corps.offsetWidth; corps.classList.add('mb-entre'); }
      }
      if (cle === 'cadrage') requestAnimationFrame(() => { c.mesurer(); if (c.dataset.etat === 'pret') c.majVoirChezMoi(); });
      /* À l'étape finale, la photo de la pièce revient à gauche : la carte de droite montre déjà votre création */
      if (atelier) { manuel = false; montrer(cle === 'oeuvre' || cle === 'composition' || (cle === 'mur' && !pret()) ? 'photos' : 'mur'); }
      maj();
      if (defiler && avant) amener(pasDe(cle));
    };
    const amener = (el) => {
      if (!el) return;
      const r = el.getBoundingClientRect();
      const haut = innerWidth < 990 ? (c.querySelector('.mb-cadreur__vivant')?.offsetHeight || 0) : 0;
      if (r.top >= haut && r.top < innerHeight * 0.4) return;
      el.scrollIntoView({ behavior: anime ? 'smooth' : 'auto', block: 'start' });
    };
    const suivante = (cle) => cles[cles.indexOf(cle) + 1];
    /* Le ton du parcours évolue (10/10, Marcel) : d'une place à faire à une œuvre prête à entrer chez vous */
    const titreParcours = c.querySelector('[data-mb-parcours-titre]');
    const compteParcours = c.querySelector('[data-mb-parcours-compte]');
    const phraseParcours = () => {
      if (etat.ouvert === 'composition') return 'Votre œuvre est prête à entrer chez vous.';
      if (etat.valides.has('matiere') && pret()) return 'Chaque détail est choisi.';
      if (etat.valides.has('cadrage') && pret()) return 'Voilà le paysage que vous contemplerez.';
      if (pret()) return 'Votre mur prend forme.';
      return 'Faisons une place à votre œuvre.';
    };
    const majParcours = () => {
      if (compteParcours) compteParcours.textContent = `· étape ${Math.max(cles.indexOf(etat.ouvert), 0) + 1} sur ${cles.length}`;
      if (!titreParcours) return;
      const t = phraseParcours();
      if (titreParcours.textContent === t) return;
      if (!anime || !titreParcours.dataset.pret) { titreParcours.textContent = t; titreParcours.dataset.pret = 'oui'; return; }
      titreParcours.classList.add('mb-sort');
      setTimeout(() => { titreParcours.textContent = t; titreParcours.classList.remove('mb-sort'); titreParcours.classList.add('mb-entre-titre'); setTimeout(() => titreParcours.classList.remove('mb-entre-titre'), 500); }, 220);
    };

    c.addEventListener('click', (e) => {
      const aller = e.target.closest('[data-mb-aller]');
      if (aller && c.contains(aller)) { ouvrir(aller.dataset.mbAller); return; }
      const echelle = e.target.closest('[data-mb-echelle]');
      if (echelle && aside) { const oui = !aside.hasAttribute('data-echelle'); aside.toggleAttribute('data-echelle', oui); echelle.setAttribute('aria-pressed', String(oui)); return; }
      const vue = e.target.closest('[data-mb-vue]');
      if (vue && atelier) { montrer(vue.dataset.mbVue, true); return; }
      const retour = e.target.closest('[data-mb-pas-precedent]');
      if (retour) { const k = cles.indexOf(retour.closest('[data-mb-pas]').dataset.mbPas); if (k > 0) ouvrir(cles[k - 1]); return; }
      const suite = e.target.closest('[data-mb-suite]');
      if (!suite) return;
      const cle = suite.closest('[data-mb-pas]').dataset.mbPas;
      if (cle === 'mur' && !pret()) {
        c.lire(true);
        if (!pret()) { const v = c.valider(); c.erreur(v.texte); (v.champ || c.el.L).focus(); return; }
      }
      etat.valides.add(cle);
      ouvrir(suivante(cle));
    });

    /* Les liens de la page vers le parcours : « Voir chez moi » ouvre le cadrage, « Choisir » une matière */
    d.addEventListener('click', (e) => {
      const lien = e.target.closest('a[data-mb-etape-cible]');
      if (lien) { ouvrir(lien.dataset.mbEtapeCible, { defiler: false }); return; }
      const m = e.target.closest('[data-mb-choisir-matiere]');
      if (!m) return;
      const radio = c.querySelector(`[data-mb-matieres] input[value="${m.dataset.mbChoisirMatiere}"]`);
      if (!radio || radio.disabled) return;
      e.preventDefault();
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      ouvrir('matiere', { defiler: false });
      (pasDe('matiere') || c).scrollIntoView({ behavior: anime ? 'smooth' : 'auto', block: 'start' });
    });

    /* Les gestes du moteur qui amènent un élément à l'écran : la bonne étape d'abord */
    const amenerCase = c.amenerCase.bind(c);
    c.amenerCase = () => { ouvrir('composition', { defiler: false }); amenerCase(); };
    const autrePiece = c.autrePiece.bind(c);
    c.autrePiece = () => { etat.valides.clear(); ouvrir('mur', { defiler: false }); autrePiece(); };
    const ajouter = c.ajouter.bind(c);
    c.ajouter = () => { if (!c.valider().ok) ouvrir('mur', { defiler: false }); return ajouter(); };
    c.addEventListener('mb-vcm:recadrer', () => { ouvrir('cadrage', { defiler: false }); requestAnimationFrame(() => c.el.vue.scrollIntoView({ block: 'center' })); });

    /* ---------- L'atelier : les photos ou votre mur, au même endroit ---------- */
    let manuel = false;
    const montrer = (v, parLeClient = false) => {
      if (!atelier) return;
      if (parLeClient) manuel = true;
      if (aside.dataset.vue === v) return;
      aside.dataset.vue = v;
      for (const b of aside.querySelectorAll('[data-mb-vue]')) b.setAttribute('aria-pressed', String(b.dataset.mbVue === v));
      if (v === 'mur') requestAnimationFrame(() => { c.poserMur(); c.mesurer(); });
    };
    const montant = c.querySelector('[data-mb-atelier-montant]');
    const detail = c.querySelector('[data-mb-atelier-detail]');
    const depart = montant ? { montant: montant.innerHTML, detail: detail ? detail.innerHTML : '' } : null;
    const majEnTete = () => {
      if (!montant) return;
      if (!pret() || c.el.prix.textContent === '—') {
        if (montant.dataset.vivant) { montant.innerHTML = depart.montant; delete montant.dataset.vivant; if (detail) { detail.innerHTML = depart.detail; exemplePremierEcran(c, true); } }
        return;
      }
      montant.dataset.vivant = 'oui';
      const t = c.el.prix.textContent;
      if (montant.textContent !== t) glisserMontant(montant, t);
      if (detail) {
        const parts = [`Votre mur de ${metres(c.L)} × ${metres(c.H)} m`];
        if (c.matiere) parts.push(c.matiere.nom);
        if (!c.el.remise.hidden && c.el.remise.textContent) parts.push(c.el.remise.textContent);
        const txt = parts.join(' · ');
        if (detail.textContent !== txt) detail.textContent = txt;
      }
    };

    /* ---------- « Ajustez votre paysage » : l'œuvre glisse dans un aperçu aux proportions exactes du mur ----------
       Même calcul que votre mur (fondMur) : taille d'image 100/fw % × 100/fh %, jamais étirée ; seul ce qui dépasse est
       recadré. Le glisser écrit x0 / y0 du moteur (bornés), qui fixent le cadrage imprimé (_cadrage) et Voir chez moi. */
    const fen = c.querySelector('[data-mb-fenetre]');
    const ajuste = c.querySelector('[data-mb-ajuste]');
    const indice = c.querySelector('[data-mb-ajuste-indice]');
    const mesuresAj = c.querySelector('[data-mb-ajuste-mesures]');
    const majFenetre = () => {
      if (!fen || !c.gL || !c.gH) return;
      const cadre = fen.parentElement;
      const r = c.gL / c.gH;
      const W = cadre.clientWidth || 320;
      const hMax = innerWidth < 990 ? 280 : 400;
      let w = W; let h = W / r;
      if (h > hMax) { h = hMax; w = h * r; }
      fen.style.width = `${Math.round(w)}px`;
      fen.style.height = `${Math.round(h)}px`;
      fen.style.backgroundImage = c.urlMur || `url("${c.dataset.image}")`;
      const x = c.borner(c.x0, 1 - c.fw), y = c.borner(c.y0, 1 - c.fh);
      fen.style.backgroundSize = `${100 / c.fw}% ${100 / c.fh}%`;
      fen.style.backgroundPosition = `${c.fw < 1 ? (x / (1 - c.fw)) * 100 : 0}% ${c.fh < 1 ? (y / (1 - c.fh)) * 100 : 0}%`;
      fen.dataset.mode = c.mode;
      const pos = c.mode === 'h' ? (c.fw < 1 ? x / (1 - c.fw) : 0.5) : (c.fh < 1 ? y / (1 - c.fh) : 0.5);
      fen.setAttribute('aria-valuenow', String(Math.round(pos * 100)));
      fen.setAttribute('aria-valuetext', `${Math.round(pos * 100)} % depuis ${c.mode === 'h' ? 'la gauche' : 'le haut'} de l’œuvre`);
      const fixe = c.mode === 'h' ? c.fw >= 0.995 : c.fh >= 0.995;
      if (indice) indice.textContent = fixe ? 'L’œuvre tient entière sur votre mur' : c.mode === 'h' ? '←  Faites glisser  →' : '↑  Faites glisser  ↓';
      if (mesuresAj && pret()) mesuresAj.textContent = `Votre mur de ${metres(c.L)} × ${metres(c.H)} m`;
    };
    const deplacer = (x0, y0) => {
      c.x0 = c.borner(x0, 1 - c.fw);
      c.y0 = c.borner(y0, 1 - c.fh);
      c.fondMur();
      majFenetre();
    };
    if (fen) {
      let depart = null;
      fen.addEventListener('pointerdown', (e) => {
        if (!pret() || e.button > 0) return;
        depart = { x: e.clientX, y: e.clientY, x0: c.x0, y0: c.y0, w: fen.clientWidth, h: fen.clientHeight, id: e.pointerId };
        fen.setPointerCapture(e.pointerId);
        fen.classList.add('mb-tenu');
        if (ajuste) ajuste.dataset.touche = 'oui';
      });
      fen.addEventListener('pointermove', (e) => {
        if (!depart || e.pointerId !== depart.id) return;
        // l'image suit le doigt : glisser vers la droite montre la partie gauche de l'œuvre
        if (c.mode === 'h') deplacer(depart.x0 - ((e.clientX - depart.x) / depart.w) * c.fw, c.y0);
        else deplacer(c.x0, depart.y0 - ((e.clientY - depart.y) / depart.h) * c.fh);
      });
      const lacher = () => { if (!depart) return; depart = null; fen.classList.remove('mb-tenu'); c.majVoirChezMoi(); };
      fen.addEventListener('pointerup', lacher);
      fen.addEventListener('pointercancel', lacher);
      fen.addEventListener('lostpointercapture', lacher);
      fen.addEventListener('keydown', (e) => {
        if (!pret()) return;
        const pas = e.shiftKey ? 0.1 : 0.02;
        const h = c.mode === 'h';
        let x = c.x0; let y = c.y0;
        if (e.key === (h ? 'ArrowLeft' : 'ArrowUp')) { if (h) x -= pas; else y -= pas; }
        else if (e.key === (h ? 'ArrowRight' : 'ArrowDown')) { if (h) x += pas; else y += pas; }
        else return;
        e.preventDefault();
        if (ajuste) ajuste.dataset.touche = 'oui';
        deplacer(x, y);
        c.majVoirChezMoi();
      });
      c.querySelector('[data-mb-recentrer]')?.addEventListener('click', () => {
        deplacer(c.defaut.x - c.fw / 2, c.defaut.y - c.fh / 2);
        c.majVoirChezMoi();
      });
      if ('ResizeObserver' in window) new ResizeObserver(() => majFenetre()).observe(fen.parentElement);
    }

    /* ---------- Tout ce qui suit l'état du moteur ---------- */
    const resume = (cle) => {
      if (cle === 'oeuvre') return pasDe('oeuvre')?.dataset.resume || '';
      if (cle === 'mur') return pret() ? `${c.L} × ${c.H} cm` : '';
      if (cle === 'cadrage') {
        if (!pret() || !c.imp) return '';
        return etat.valides.has('cadrage') ? 'Ajusté à votre mur' : '';
      }
      if (cle === 'matiere') return c.matiere ? `${c.matiere.nom} · ${sansZero(euros(c.matiere.centimes))}/m²` : '';
      if (cle === 'composition') return pret() && c.el.prix.textContent !== '—' ? c.el.prix.textContent : '';
      return '';
    };
    const fait = (cle) => {
      if (cle === 'oeuvre') return true;
      if (cle === 'mur') return pret();
      if (cle === 'composition') return pret() && c.el.verif.checked;
      return pret() && etat.valides.has(cle);
    };

    const recu = c.querySelector('[data-mb-recu]');
    const avantages = c.querySelector('[data-mb-avantages]');
    const listeAv = c.querySelector('[data-mb-avantages-liste]');
    const suiteAv = c.querySelector('[data-mb-avantages-suite]');
    const R = window.mbRemises || { paliers: [], murs: [] };
    if (listeAv && listeAv.children.length === 0) {
      const ligne = (cle, nom, valeur, pct) => {
        const li = d.createElement('li');
        li.dataset.cle = cle;
        if (pct) li.dataset.pct = String(pct);
        const a = d.createElement('span'); a.textContent = nom;
        const b = d.createElement('b'); b.textContent = valeur;
        li.append(a, b);
        listeAv.append(li);
      };
      for (const m of [...R.murs].sort((x, y) => x.murs - y.murs)) ligne(m.nom, `${m.nom} ou plus`, `−${m.pct} %`);
      for (const x of [...R.paliers].sort((a, b) => a.seuil - b.seuil)) ligne('Tarif grands murs', `Projet dès ${new Intl.NumberFormat('fr-FR').format(x.seuil / 100)} €`, `−${x.pct} %`, x.pct);
    }

    const majRecu = () => {
      if (!recu) return;
      recu.replaceChildren();
      if (!pret() || !c.imp) return;
      const ajout = (dt, dd) => {
        const div = d.createElement('div');
        const a = d.createElement('dt'); a.textContent = dt;
        const b = d.createElement('dd'); b.textContent = dd;
        div.append(a, b);
        recu.append(div);
      };
      ajout('Dimensions', `Mur de ${metres(c.L)} × ${metres(c.H)} m\nimprimé ${c.imp.w} × ${c.imp.h} cm`);
      ajout('Paysage', cles.includes('cadrage') ? 'Ajusté par vous, sur tout le mur' : 'Motif répété sur tout le mur');
      if (c.matiere) ajout('Matière', `${c.matiere.nom} · ${sansZero(euros(c.matiere.centimes))}/m²`);
    };

    const majAvantages = () => {
      if (!avantages) return;
      avantages.hidden = !pret() || !!c.horsLimite;
      if (avantages.hidden) return;
      const dv = c.devis || { nb: 1, remise: null };
      for (const li of listeAv.children) li.toggleAttribute('data-actif', !!(dv.remise && dv.remise.nom === li.dataset.cle && (!li.dataset.pct || Number(li.dataset.pct) === dv.remise.pct)));
      let phrase = '';
      const deux = R.murs.find((m) => m.murs === 2);
      const trois = R.murs.find((m) => m.murs === 3);
      if (dv.nb <= 1 && !dv.remise && deux) phrase = `Un deuxième mur, dans cette pièce ou une autre : −${deux.pct} % sur vos murs.`;
      else if (dv.nb === 2 && trois && (!dv.remise || dv.remise.pct < trois.pct)) phrase = `Encore une œuvre, et la Maison vous offre −${trois.pct} % sur l’ensemble.`;
      if (suiteAv.textContent !== phrase) suiteAv.textContent = phrase;
    };

    const majMatieres = () => {
      const radios = [...c.querySelectorAll('[data-mb-matieres] input[type="radio"]')];
      if (!radios.length) return;
      const imp = c.imp;
      for (const r of radios) {
        const carte = r.closest('.mb-matiere');
        const total = carte && carte.querySelector('[data-mb-matiere-total]');
        if (total) {
          let texte = '';
          if (imp) {
            const t = c.tarifImprime(imp.w, imp.h, parseInt(r.dataset.prix, 10) / 100);
            if (t && t.centimes != null) texte = (c.panierMurs && c.panierMurs.length) ? euros(t.centimes) : t.prix;
          }
          total.textContent = texte;
          total.dataset.exemple = pret() ? 'non' : 'oui';
        }
      }
      const fs = c.querySelector('[data-mb-matieres]');
      const conseil = fs && (fs.dataset.format === 'panoramique' || (pret() && c.L >= 400)) ? 'Intissé lisse' : 'Textile adhésif';
      for (const b of c.querySelectorAll('[data-mb-choix-maison]')) b.hidden = b.closest('.mb-matiere').dataset.nom !== conseil;
      const choisie = radios.find((r) => r.checked);
      for (const det of c.querySelectorAll('[data-mb-matiere-detail]')) det.hidden = !choisie || det.dataset.mbMatiereDetail !== choisie.value;
      const legende = c.querySelector('[data-mb-matieres-legende]');
      if (legende) legende.textContent = pret() ? '' : 'Prix pour l’exemple de 3 × 2,5 m';
    };

    const vivant = c.querySelector('[data-mb-pas-vivant]');
    const majVivant = () => {
      if (!vivant) return;
      vivant.hidden = !pret() || !c.imp;
      if (vivant.hidden) return;
      const t = `Imprimé ${c.imp.w} × ${c.imp.h} cm · ${c.el.surface.textContent} · ${c.el.prix.textContent}${c.matiere ? ` en ${c.matiere.nom}` : ''}`;
      if (vivant.textContent !== t) vivant.textContent = t;
    };
    const fin = { mur: c.querySelector('[data-mb-final]'), dims: c.querySelector('[data-mb-final-dims]'), montant: c.querySelector('[data-mb-final-montant]'), barre: c.querySelector('[data-mb-final-barre]'), detail: c.querySelector('[data-mb-final-detail]') };
    const att = { boite: c.querySelector('[data-mb-attentions]'), etat: c.querySelector('[data-mb-attentions-etat]'), jauge: c.querySelector('[data-mb-attentions-jauge]'), rempli: c.querySelector('[data-mb-attentions-rempli]') };
    let remiseAvant = null;
    const majFinal = () => {
      if (!fin.montant) return;
      if (fin.mur && c.gL && c.gH && c.imp) {
        const cadre = fin.mur.parentElement;
        const r = c.gL / c.gH;
        const W = cadre.clientWidth || 320; const hMax = innerWidth < 990 ? 220 : 280;
        let w = W; let h = W / r; if (h > hMax) { h = hMax; w = h * r; }
        fin.mur.style.width = `${Math.round(w)}px`; fin.mur.style.height = `${Math.round(h)}px`;
        const s2 = c.el.mur.style;
        fin.mur.style.backgroundImage = s2.backgroundImage; fin.mur.style.backgroundSize = s2.backgroundSize;
        fin.mur.style.backgroundPosition = s2.backgroundPosition; fin.mur.style.backgroundRepeat = s2.backgroundRepeat || 'no-repeat';
      }
      if (fin.dims) fin.dims.textContent = pret() ? `${metres(c.L)} × ${metres(c.H)} m` : '';
      if (!pret()) { fin.montant.textContent = '—'; delete fin.montant.dataset.centimes; if (fin.barre) fin.barre.hidden = true; if (att.boite) att.boite.hidden = true; return; }
      glisserMontant(fin.montant, c.el.prix.textContent);
      if (fin.barre) { fin.barre.textContent = c.el.barre.textContent; fin.barre.hidden = c.el.barre.hidden; }
      if (fin.detail) fin.detail.textContent = `${c.el.surface.textContent} · ${c.querySelector('[data-mb-m2]')?.textContent || ''}`;
      // Les attentions de la Maison : débloquée, ou à portée (seulement quand cela a du sens)
      if (!att.boite) return;
      const dv = c.devis || { nb: 1, remise: null, sousTotal: 0 };
      att.boite.hidden = !!c.horsLimite;
      for (const li of (listeAv ? listeAv.children : [])) li.toggleAttribute('data-actif', !!(dv.remise && dv.remise.nom === li.dataset.cle && (!li.dataset.pct || Number(li.dataset.pct) === dv.remise.pct)));
      const paliers = [...R.paliers].sort((a, b) => a.seuil - b.seuil);
      const prochain = paliers.find((p) => dv.sousTotal < p.seuil);
      const deux = R.murs.find((m) => m.murs === 2); const trois = R.murs.find((m) => m.murs === 3);
      let html = ''; let jauge = 0;
      const nomRemise = (r) => (r.nom === 'Tarif grands murs' ? 'Tarif grands murs' : `${r.nom} ou plus`);
      if (dv.remise) {
        html = `<p class="mb-attentions__ok">Votre avantage Maison est débloqué</p><p class="mb-attentions__ligne">${nomRemise(dv.remise)} : −${dv.remise.pct} % · <b>−${euros(dv.remise.montant)}</b></p>`;
        if (prochain && dv.remise.nom === 'Tarif grands murs' && prochain.pct > dv.remise.pct && prochain.seuil - dv.sousTotal <= prochain.seuil * 0.3) { html += `<p class="mb-attentions__suite">Plus que ${euros(prochain.seuil - dv.sousTotal)} pour passer à −${prochain.pct} %.</p>`; jauge = dv.sousTotal / prochain.seuil; }
        else if (dv.nb === 2 && trois && dv.remise.pct < trois.pct) html += `<p class="mb-attentions__suite">Encore une œuvre, et la Maison vous offre −${trois.pct} % sur l’ensemble.</p>`;
      } else if (prochain && prochain.seuil - dv.sousTotal <= prochain.seuil * 0.3) { // à portée seulement : moins de 30 % du seuil
        html = `<p class="mb-attentions__suite">Plus que <b>${euros(prochain.seuil - dv.sousTotal)}</b> et votre projet profite de −${prochain.pct} %.</p>`; jauge = dv.sousTotal / prochain.seuil;
      } else if (dv.nb <= 1 && deux) {
        html = `<p class="mb-attentions__suite">Un deuxième mur, dans cette pièce ou une autre&nbsp;: −${deux.pct} % sur vos murs.</p>`;
      } else if (dv.nb === 2 && trois) {
        html = `<p class="mb-attentions__suite">Encore une œuvre, et la Maison vous offre −${trois.pct} % sur l’ensemble.</p>`;
      }
      if (att.etat.innerHTML !== html) att.etat.innerHTML = html;
      att.boite.toggleAttribute('data-debloque', !!dv.remise);
      if (dv.remise && !remiseAvant && anime) { att.boite.classList.remove('mb-recompense'); void att.boite.offsetWidth; att.boite.classList.add('mb-recompense'); }
      remiseAvant = dv.remise ? dv.remise.nom + dv.remise.pct : null;
      if (att.jauge) { att.jauge.hidden = !jauge; if (jauge && att.rempli) att.rempli.style.transform = `scaleX(${Math.min(jauge, 1).toFixed(3)})`; }
    };

    let dernierPrix = '';
    const maj = () => {
      let n = 0;
      for (const p of pas) {
        const cle = p.dataset.mbPas;
        const f = fait(cle);
        if (f) n += 1;
        p.toggleAttribute('data-fait', f);
        const res = p.querySelector('[data-mb-pas-resume]');
        const t = resume(cle);
        if (res && res.textContent !== t) res.textContent = t;
      }
      if (prog) {
        for (const li of prog.children) {
          const cle = li.dataset.pas;
          li.dataset.etat = cle === etat.ouvert ? 'actif' : fait(cle) ? 'fait' : 'avenir';
          const b = li.querySelector('button');
          if (b) {
            if (cle === etat.ouvert) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
            b.setAttribute('aria-label', `${li.textContent.trim()}, étape ${cles.indexOf(cle) + 1} sur ${cles.length}${fait(cle) ? ', faite' : ''}`);
          }
        }
        const i = Math.max(cles.indexOf(etat.ouvert), 0);
        prog.style.setProperty('--mb-progres', String(cles.length > 1 ? i / (cles.length - 1) : 1));
        prog.dataset.faites = String(n);
      }
      majRecu();
      majAvantages();
      majMatieres();
      majEnTete();
      majFenetre();
      majVivant();
      majFinal();
      majParcours();
      if (atelier && !manuel && pret() && etat.ouvert === 'mur') montrer('mur');
      // le prix qui change : un battement discret du total et de la pastille (opacity, transform)
      const prix = c.el.prix.textContent;
      if (anime && pret() && dernierPrix && prix !== dernierPrix) {
        for (const el of [c.el.prix.parentElement, c.el.vivant]) {
          if (!el) continue;
          el.classList.remove('mb-bat'); void el.offsetWidth; el.classList.add('mb-bat');
        }
      }
      dernierPrix = prix;
    };

    c.addEventListener('mb-cadreur:prix', maj);
    c.el.verif.addEventListener('change', maj);
    c.addEventListener('change', (e) => { if (e.target.matches('[data-mb-matieres] input, [data-mb-rendu] input')) requestAnimationFrame(maj); });
    c.el.vue.addEventListener('pointerup', () => requestAnimationFrame(maj));
    c.el.cadre.addEventListener('keyup', () => requestAnimationFrame(maj));

    ouvrir('mur', { defiler: false });
  }

  /* L'exemple du premier écran : le premier format du parcours, au prix le plus bas (la matière présélectionnée) */
  function exemplePremierEcran(c, encore = false) {
    const el = d.querySelector('[data-mb-exemple-prix]');
    if (!el || (el.dataset.pret && !encore)) return;
    const f = c.querySelector('[data-mb-format]');
    if (!f) return;
    const l = parseInt(f.dataset.l, 10), h = parseInt(f.dataset.h, 10);
    if (!(l > 0 && h > 0) || typeof c.tarifImprime !== 'function') return;
    const radios = [...c.querySelectorAll('[data-mb-matieres] input[type="radio"]')];
    const plusBas = radios.length ? Math.min(...radios.map((r) => parseInt(r.dataset.prix, 10) || Infinity)) / 100 : c.prixM2;
    const t = c.tarifImprime(l, h, plusBas); // 16/10 : plus de marge ajoutée (MB_MARGE = 0)
    if (!t || t.centimes == null) return;
    const nom = (f.dataset.nom || f.querySelector('.mb-format__nom')?.textContent || '').trim();
    el.textContent = `${nom ? `${nom} de ` : ''}${metres(l)} × ${metres(h)} m : ${radios.length > 1 ? 'dès ' : ''}${t.prix}.`;
    el.hidden = false;
    el.dataset.pret = 'oui';
  }
})();
